import { Get, Pick } from "@/api/utils";
import { IGetAPIProgram, IGetMeetingLive, IGetGetPhotoClass, IGetPhotoInfo, IGetPhotoPageInfo } from "./index.dto";

const API_HOST = "";

export const GetAPIProgram = {
  Get_Program: API_HOST + "/api/Program/GetAPIProgram", //会议基本信息接口
  Get_MeetingLive: API_HOST + "/api/Live/InitWeiQiMeetingLive", //嘉宾日程信息接口
  Get_PhotoClass: API_HOST + "/api/Photo/GetPhotoClass", //获取照片分类列表首页
  Get_PhotoInfo: API_HOST + "/api/Photo/GetPhotoInfo", //照片直播详情页面，首次进入调用
  Get_PhotoPageInfo: API_HOST + "/api/Photo/GetPhotoPageInfo", //分页加载照片列表
};
export default {
  /**
   * @title 获取照片分类列表首页
   * @date 2021-01-12
   */
  GetPhotoClass(body: IGetGetPhotoClass) {
    const params = Pick(body, IGetGetPhotoClass);
    return Get({
      url: GetAPIProgram.Get_PhotoClass,
      params,
    });
  },
  /**
   * @title 照片直播详情页面，首次进入调用
   * @date 2021-01-12
   */
  GetPhotoInfo(body: IGetPhotoInfo) {
    const params = Pick(body, IGetPhotoInfo);
    return Get({
      url: GetAPIProgram.Get_PhotoInfo,
      params,
    });
  },
  /**
   * @title 分页加载照片列表
   * @date 2021-01-12
   */
  GetPhotoPageInfo(body: IGetPhotoPageInfo) {
    const params = Pick(body, IGetPhotoPageInfo);
    return Get({
      url: GetAPIProgram.Get_PhotoPageInfo,
      params,
    });
  },
  /**
   * @title 获取当前会议日程信息
   * @date 2020-11-24
   */
  GetAPIProgram(body: IGetAPIProgram) {
    const params = Pick(body, IGetAPIProgram);
    return Get({
      url: GetAPIProgram.Get_Program,
      params,
    });
  },
  /**
   * @title 直播间页面接口
   * @date 2020-11-24
   */
  GetMeetingLive(body: IGetMeetingLive) {
    const params = Pick(body, IGetMeetingLive);
    return Get({
      url: GetAPIProgram.Get_MeetingLive,
      params,
    });
  },
};
